import React, { useState, useEffect } from 'react'
import { Typography, TextField, IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

const useStyles = makeStyles((theme) => ({
    inputRowContainer: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: "space-between", 
        width: "30%", 
        marginBottom: "10px" 
    },
    deleteButton: {
        '&:hover svg': {
            fill: theme.palette.secondary.main
        }
    }
}))

export default function TimeBracketInput({ number, value, removeInput, hideDeleteButton, updateTimeBracket, validateValue }) {
    const classes = useStyles()
    const [ timeValue, setTimeValue ] = useState(value)
    const [ hasErrors, setHasErrors ] = useState(false)
    const [ errorMessage, setErrorMessage ] = useState('')

    useEffect(() => {
        const { isValid, errorMessage } = validateValue(timeValue)
        setHasErrors(!isValid)
        setErrorMessage(errorMessage)
        
    }, [ timeValue ])

    function hanleUpdateTimeBracket (e) {
        const seconds = minutesToSeconds(e.currentTarget.value)
        setTimeValue(seconds)
        updateTimeBracket(seconds, number - 1)
    }

    function secondsToMinutes (seconds) {
        return Math.floor(seconds / 60)
    }

    function minutesToSeconds (minutes) {
        return Math.floor(minutes * 60)
    }

    return (
        <div className={classes.inputRowContainer} >
            <Typography variant="h6">{`Isochrone ${number}`}</Typography>
            <TextField 
                variant="filled"
                autoFocus
                value={secondsToMinutes(timeValue)} 
                type="number" 
                error={hasErrors}
                helperText={errorMessage}
                onChange={e => hanleUpdateTimeBracket(e)}
            />
            <IconButton onClick={() => removeInput(number - 1)} disabled={hideDeleteButton} className={classes.deleteButton}>
                <HighlightOffIcon  />
            </IconButton>
        </div>
    )
}